import React, { useEffect, useState } from "react";
import ApexChart from "react-apexcharts";
import { apexHorizontalBarChartDefaultOption } from "constants/ChartConstant";
import { cloneDeep } from "lodash";

const HorizontalBarChart = ({ series, categories, height, customOptions, formatValue }) => {
  const [options, setOptions] = useState(apexHorizontalBarChartDefaultOption);

  useEffect(() => {
    const newOptions = cloneDeep(apexHorizontalBarChartDefaultOption);

    // Set categories
    newOptions.xaxis.categories = categories;

    // Apply custom formatting if provided
    if (formatValue) {
      newOptions.dataLabels.formatter = formatValue;
      newOptions.xaxis.labels.formatter = formatValue;
      newOptions.tooltip.y.formatter = formatValue;
    }

    // Merge with custom options
    if (customOptions) {
      Object.assign(newOptions, customOptions);
    }

    setOptions(newOptions);
  }, [categories, customOptions, formatValue]);

  return (
    <div>
      <ApexChart options={options} series={series} type="bar" height={height || 300} />
    </div>
  );
};

export default HorizontalBarChart;
